export const slick_obj = () => {

  return {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  }
}

export const textarea_auto_resize = ($) => {

  $('textarea').each(function () {})
    .on('input', function () {

      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
  });
}

export const builder_js = (ww, $) => {

  if (!window.builder_js) {
    return;
  }

  Object.keys(window.builder_js).forEach((key) =>  {
    window.builder_js[key](ww, $);
  });
}